import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as InventarioCrud from 'services/inventario.service'

import { DownloadAxiosFile } from 'utils'

const ReporteGeneralStock = () => {
  const __zariContext = React.useContext(ZariContext)
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const clickDescargarReporteHandler = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte - General Stock...')
    InventarioCrud.getReporteGeneralStock()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    InventarioCrud.consultaGeneralStock()
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Reporte General Stock' />
      <Portlet.Body>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarReporteHandler}>Descargar</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>CODIGO</th>
                      <th>PRODUCTO</th>
                      <th>STOCK</th>
                      <th>U.M.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.codigo}</td>
                        <td>{r.nombre}</td>
                        <td className='text-right'>{r.stock}</td>
                        <td>{r.unidadMedida}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteGeneralStock)
